import { Injectable } from '@angular/core';
import { HttpUtilService } from '@services/http-util.service';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class ViewsService {
  update = new BehaviorSubject<View>(null);
  constructor(public http: HttpUtilService) {}

  getViews(url): Observable<any> {
    return this.http.request(
      'GET',
      environment.apiRoot + url,
      null,
      null,
      true
    );
  }

  /**
   * Create a new mode for the specified data type
   * @param type Data type for the mode
   * @param mode Name for the new mode
   * @param data Starting values for the data
   */
  createMode(type: string, mode: string, data): Observable<any> {
    const mode_data = {
      data: data,
      type: type,
    };
    const req = this.http.request(
      'POST',
      environment.apiRoot + '/views?mode=' + mode,
      mode_data,
      null,
      true
    );
    return req;
  }
  /**
   * Save a mode
   * @param data Mode to update
   */
  saveForm(data: any): Observable<any> {
    return this.http.request(
      'PUT',
      environment.apiRoot + '/views/' + (data.view_id || data.id),
      { data: data.data, type: data.type },
      null,
      true
    );
  }
  /**
   * Get all modes for the specified type
   * @param type
   */
  getModes(type: string): Observable<any> {
    return this.http.request(
      'GET',
      environment.apiRoot + '/views?type=' + type,
      null,
      null,
      true
    );
  }
  /**
   * Create an overide view for the specified parent view
   * @param id: Parent view ID
   */
  updateOverrideView(id: string | number): Observable<any> {
    return this.http.request(
      'PUT',
      `${environment.apiRoot}/views/${id}?updateoverridden=true`,
      {},
      null,
      true
    );
  }
}

/**Mode for displaying data in Scaffold */
export class View {
  institution: string;
  id: any;
  title: string;
  data_store_id: any;
  view_id: any;
  link: any;
  type: string;
  data: any = {
    content: [],
  };
}
